// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"image-panel-module--wrapper--1FOmZ","slider":"image-panel-module--slider--1xBAf","image":"image-panel-module--image--8lvYv"};